import { render, staticRenderFns } from "./LabelReleasesCostsplittingDialog.vue?vue&type=template&id=ef21cbd6"
import script from "./LabelReleasesCostsplittingDialog.vue?vue&type=script&lang=js"
export * from "./LabelReleasesCostsplittingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports